"use client";

import Image, { StaticImageData } from "next/image";

import { Heading4 } from "@/components/text/Heading4";

export function ImageShowcase({
  screenshot,
  headingText,
  altText,
  children,
}: {
  screenshot: StaticImageData;
  headingText: string;
  altText: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-center rounded-3xl bg-primaryLight px-4 sm:px-10 md:flex-row md:gap-x-8 lg:gap-x-24">
      <Image
        src={screenshot}
        alt={altText}
        className="rotate-2 rounded-lg shadow-lg md:w-1/2 md:shadow-2xl"
        quality={100}
      />
      <div className="py-6 md:w-1/2">
        <Heading4 elementType="h3" className="mb-2">
          {headingText}
        </Heading4>
        {children}
      </div>
    </div>
  );
}
